import clsx from 'clsx';

const MailboxIcon = ({
  height = '120px',
  width = '120px',
  className,
}: {
  height?: string | number;
  width?: string | number;
  className?: string;
}) => (
  <img
    src="/assets/images/mailbox.png"
    alt=""
    height={height}
    width={width}
    className={clsx('object-contain', className)}
  />
);

export default MailboxIcon;
